import type { NormalizeEntityPointToPolyLine2OptsForceXToRoomWidth, Position } from "building-types/rooms/roomPosition";
import { vec2Scale } from "geom/vec2";
import { normalizePointToPolyLine2 } from "./normalizePointToPolyLine2";

export function normalizeEntityPointToPolyLine2ForceXToRoomWidth({
  tx,
  ty,
  nx,
  ny,
  entityPlaneYOffset,
  entityPlaneXOffset,
  entityPlaneYNormalizedToRoomWidth,
  entityPlaneXNormalizedToRoomWidth,
  bbx,
  bby,
  outline,
  reverse,
}: NormalizeEntityPointToPolyLine2OptsForceXToRoomWidth): Position {
  const [stx, sty] = vec2Scale(tx, ty, 0);
  const [snx, sny] = vec2Scale(nx, ny, entityPlaneYOffset);
  const [x, y] = [bbx + stx + snx, bby + sty + sny];

  if (entityPlaneYNormalizedToRoomWidth) {
    const result = normalizePointToPolyLine2(outline, bbx, bby, nx, ny, entityPlaneYOffset);
    const result2 = normalizePointToPolyLine2(
      outline,
      result ? result[0] : bbx,
      result ? result[1] : bby,
      tx,
      ty,
      entityPlaneXOffset,
      entityPlaneXNormalizedToRoomWidth,
      reverse,
    );

    if (result) {
      return { location: [result[0], result[1]], normal: [-tx, -ty] };
    }

    if (result2) {
      return { location: [result2[0], result2[1]], normal: [-tx, -ty] };
    }

    return { location: [x, y], normal: [-tx, -ty] };
  }

  const result = normalizePointToPolyLine2(
    outline,
    bbx + snx,
    bby + sny,
    tx,
    ty,
    entityPlaneXOffset,
    entityPlaneXNormalizedToRoomWidth,
    reverse,
  );

  return { location: result ? [result[0], result[1]] : [x, y], normal: [-tx, -ty] };
}
